import { ChangeDetectionStrategy, Component, DestroyRef, HostListener, Input, OnInit } from '@angular/core';
import { EventType, NavigationEnd, Router } from '@angular/router';
import { SidebarItem } from '../model/navigation-item';
import { filter, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-sidebar-container',
  templateUrl: './sidebar-container.component.html',
  styleUrls: ['./sidebar-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarContainerComponent implements OnInit {
  @Input({ required: true }) titleKey!: string;
  @Input({ required: true }) sidebarItems!: SidebarItem[];

  isOpen = true;

  // The following hostListener is used to determine the window width to resize
  // the sidebar when the window width goes below the breakpoint value.
  windowWidth = window.innerWidth;
  responsiveBreakPoint = 1024;

  @HostListener('window:resize', ['$event']) onResize(): void {
    if (window.innerWidth !== this.windowWidth) {
      this.windowWidth = window.innerWidth;
      this.isOpen = window.innerWidth > this.responsiveBreakPoint;
    }
  }

  constructor(
    private readonly router: Router,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.isOpen = this.windowWidth > this.responsiveBreakPoint;

    this.router.events
      .pipe(
        startWith(new NavigationEnd(0, this.router.url, this.router.url)),
        filter((event): event is NavigationEnd => event.type === EventType.NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(({ urlAfterRedirects }) => {
        const url = urlAfterRedirects.split('/')[2];
        this.sidebarItems.forEach(item => {
          item.isActive = url === item.pathKey;
        });
      });
  }
}
